import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  TextField,
  FormControl,
  FormHelperText,
  Divider,
} from '@mui/material';
import { useFormikContext, getIn } from 'formik';

import DeleteIcon from '@mui/icons-material/Delete';
import FileTypSelectbox from '../../common/form/selectbox/FileTypSelectbox';
import MultiUploadComponent from '../../common/form/MultiUploadComponent';

const ProjectTechMultiFileForm = ({
  file,
  index,
  touched,
  errors,
  handleRemove,
  handleChange,
  handleBlur,
}) => {
  const formikProps = useFormikContext();

  //console.log(formikProps,'form')

  const fileAttrVal2 = `files[${index}].fileAttrVal2`;
  const touchedFileAttrVal2 = getIn(touched, fileAttrVal2);
  const errorFileAttrVal2 = getIn(errors, fileAttrVal2);

  const fileVal = `files[${index}].file`;
  const touchedFile = getIn(touched, fileVal);
  const errorFile = getIn(errors, fileVal);

  const fileDesc = `files[${index}].fileDesc`;
  const touchedFileDesc = getIn(touched, fileDesc);
  const errorFileDesc = getIn(errors, fileDesc);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 2,
          px: 2,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={2}>
            <FileTypSelectbox
              index={index}
              formik={formikProps}
              touched={touchedFileAttrVal2}
              errored={errorFileAttrVal2}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PROJECT',
                slcCd: 'TECH_FILE_TYP',
                useYn: 'Y',
              }}
              fullWidth
              variant="standard"
              required
              name="fileAttrVal2"
              label="파일 유형"
            />
          </Grid>
          <Grid item xs={4}>
            <MultiUploadComponent index={index} formik={formikProps} />
            {touchedFile && Boolean(errorFile) && (
              <FormControl error>
                <FormHelperText>{touchedFile && errorFile}</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid item xs={5}>
            <TextField
              variant="standard"
              fullWidth
              name={fileDesc}
              id={fileDesc}
              value={formikProps.values.files[index].fileDesc}
              helperText={touchedFileDesc && errorFileDesc ? errorFileDesc : ''}
              error={Boolean(touchedFileDesc && errorFileDesc)}
              onChange={handleChange}
              onBlur={handleBlur}
              label="비고"
            />
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="delete" onClick={handleRemove}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ my: 1 }} />
    </>
  );
};

export default ProjectTechMultiFileForm;
